import { Download, Share, X } from 'lucide-react'
import { useInstallPrompt } from '../hooks/useInstallPrompt'
import { useStandaloneMode } from '../hooks/useStandaloneMode'
import { useMediaQuery } from '../hooks/useMediaQuery'
import { isIOS } from '../lib/pwaUtils'

export function InstallPromptBanner() {
  const { canPrompt, isDismissed, promptInstall, dismiss } = useInstallPrompt()
  const isStandalone = useStandaloneMode()
  // Phones + tablets only — installing a PWA on a laptop isn't a meaningful
  // experience (users will just keep using the browser).
  const isMobileOrTablet = useMediaQuery('(max-width: 1024px)')

  // Already installed or in standalone mode -- nothing to show
  if (isStandalone) return null
  if (!isMobileOrTablet) return null

  // iOS: show manual instructions (no beforeinstallprompt support)
  const showIOSBanner = isIOS() && !isDismissed

  // Neither Chromium prompt nor iOS banner applicable
  if (!canPrompt && !showIOSBanner) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-md rounded-lg border border-primary/30 bg-background/95 px-4 py-3 shadow-lg backdrop-blur-sm sm:left-auto sm:right-4 sm:bottom-4">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5">
          <Download className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-foreground">Install CC Platform</p>
          {canPrompt ? (
            <p className="mt-1 text-xs text-muted-foreground">
              Add to your home screen for quick access
            </p>
          ) : (
            <p className="mt-1 text-xs text-muted-foreground">
              Tap <Share className="inline h-3.5 w-3.5 -mt-0.5" /> Share, then &ldquo;Add to Home Screen&rdquo;
            </p>
          )}
          {canPrompt && (
            <button
              onClick={promptInstall}
              className="mt-2 rounded-md bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
            >
              Install
            </button>
          )}
        </div>
        <button
          onClick={dismiss}
          className="flex-shrink-0 rounded-md p-1 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
          aria-label="Dismiss install banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
